<template>
  <div class="info-container">
    <div class="up-box">
      <div
        class="inf-cell"
        v-for="(item, i) in userobj"
        @click="topage(item)"
        v-bind:key="i"
      >
        <div class="cell-left">
          <span>{{ item.txt }}</span>
        </div>
        <span>{{ item.val }}<i class="my-right"/></span>
      </div>
    </div>
    <div class="down-box">
      <div class="public-btn" @click.stop="goBack">
        <span>退出</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "information",
  data() {
    return {
      userobj: [
        { key: "nick_name", txt: "姓名", val: "张丹" },
        { key: "unit", txt: "单位名称", val: "新疆机场" },
        { key: "account_id", txt: "联系方式", val: "13212341234" }
      ]
    };
  },
  mounted() {
    let that = this;
    let _user = that.$storage.get("upmsUser");
    const flag = Object.prototype.toString.call(_user) === "[object Object]";
    for (let i = 0; i < that.userobj.length; i++) {
      that.userobj[i].val = flag ? _user[that.userobj[i].key] : "";
    }
  },
  methods: {
    goBack() {
      this.$router.push("/");
    },
    topage(data) {
      this.$router.push({
        name: "update",
        params: {
          data
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/index";
.info-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  width: 100%;
  .up-box {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    height: 25%;
    width: 95%;
    background-image: linear-gradient(180deg, #2a2e32 0%, #34393e 100%);
    border-radius: 8px;
    margin-top: px2rem(20);
    .inf-cell {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      height: 50%;
      width: px2rem(315);
      color: rgb(160, 162, 164);
      border-bottom: 1px solid rgb(66, 70, 73);
      .cell-left {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        color: #ffffff;
      }
      .my-right {
        border: solid rgb(151, 151, 151);
        border-width: 0 1px 1px 0;
        display: inline-block;
        padding: 3px;
        margin-left: px2rem(10);
        transform: rotate(-45deg);
        -webkit-transform: rotate(-45deg);
      }
    }
    > .inf-cell:last-child {
      border: 0;
    }
  }
  .down-box {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
}
</style>
